"use client";

import React from "react";
import { ArrowRight, House, MapPin, Clock, User, Mail, Phone, Star, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function ExpertHandymanSolutionsForYourHome() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: <House className="size-5 text-[var(--accent-gold)]" />,
    title: "Great Homes",
    desc: "UNDER $650K"
  }, {
    icon: <MapPin className="size-5 text-[var(--accent-gold)]" />,
    title: "Top School",
    desc: "Areas"
  }, {
    icon: <Clock className="size-5 text-[var(--accent-gold)]" />,
    title: "Minutes to",
    desc: "Naperville"
  }];
  const testimonials = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/buyer_avatar_1.png"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/buyer_avatar_2.png"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/buyer_avatar_3.png"
  }];
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    try {
      await fetch("https://anish-leads.ngrok.app/webhook/lead-form", {
        method: "POST",
        body: formData
      });
      window.location.href = "/thank-you";
    } catch (error) {
      alert("Something went wrong.");
    }
  };
  return <section data-section-id="226495" id="the-suburban-alternative" className="relative w-full min-h-screen flex items-center overflow-hidden bg-black">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/modern_suburban_home_sunset.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/modern_suburban_home_sunset.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/modern_suburban_home_sunset.png-wvc-sizes" alt="Modern Midwest brick home at sunset" className="w-full h-full object-cover opacity-70" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-transparent" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 py-20">
        <div ref={contentRef} className={`max-w-4xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="flex items-center gap-2 mb-6">
            <House className="size-5 text-[var(--accent-gold)]" />
            <span className="text-[var(--accent-gold)] font-sans font-bold uppercase tracking-widest text-sm">
              Naperville Lifestyle
            </span>
          </div>

          {}
          <h1 className="font-default font-bold text-5xl md:text-7xl text-white leading-[1.1] tracking-tight mb-6">Want the Naperville lifestyle without the <span className="text-[var(--accent-gold)]" data-ast-id="f:/src/pages/Home/sections/ExpertHandymanSolutionsForYourHome.tsx|sig:m97tye" data-ast-start="2760" data-ast-end="2985" contenteditable="false">$700K+</span> price?</h1>

          {}
          <p className="text-lg md:text-xl text-white/80 max-w-xl font-sans leading-relaxed mb-10">See Homes before they hit Zillow.<br />Discover amazing homes in Lisle, Aurora, Oswego, Plainfield, Bolingbrook and more — all close to Naperville but for thousands less.</p>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
            {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                <div className="size-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/10">
                  {feature.icon}
                </div>
                <div>
                  <p className="text-white font-bold text-sm leading-tight">{feature.title}</p>
                  <p className="text-white/60 text-xs uppercase tracking-wider">{feature.desc}</p>
                </div>
              </div>)}
          </div>

          {}
          <div className="max-w-md">
          <FormProvider>
          <form onSubmit={handleSubmit}>
              <div className="p-8 bg-black/40 backdrop-blur-md rounded-xl border border-white/10 shadow-2xl">
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="relative">
                      <User className="absolute left-4 top-1/2 -translate-y-1/2 size-5 text-white/40" />
                      <input name="first_name" type="text" placeholder="First Name" className="w-full h-14 pl-12 pr-4 rounded-lg bg-white/10 border border-white/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[var(--accent-gold)]/50 transition-all" required />
                    </div>
                    <div className="relative">
                      <input name="last_name" type="text" placeholder="Last Name" className="w-full h-14 px-4 rounded-lg bg-white/10 border border-white/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[var(--accent-gold)]/50 transition-all" required />
                    </div>
                  </div>
                  <div className="relative">
                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 size-5 text-white/40" />
                    <input name="email" type="email" placeholder="Email Address" className="w-full h-14 pl-12 pr-4 rounded-lg bg-white/10 border border-white/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[var(--accent-gold)]/50 transition-all" required />
                  </div>
                  <div className="relative">
                    <Phone className="absolute left-4 top-1/2 -translate-y-1/2 size-5 text-white/40" />
                    <input name="phone" type="tel" placeholder="Phone Number" className="w-full h-14 pl-12 pr-4 rounded-lg bg-white/10 border border-white/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[var(--accent-gold)]/50 transition-all" required />
                  </div>
                  
                  <div className="relative">
                    <MessageSquare className="absolute left-4 top-1/2 -translate-y-1/2 size-5 text-white/40" />
                    <input name="looking_for" type="text" placeholder="What are you looking for?" className="w-full h-14 pl-12 pr-4 rounded-lg bg-white/10 border border-white/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[var(--accent-gold)]/50 transition-all" />
                  </div>

                  <Button type="submit" size="lg" className="group w-full h-14 text-base font-bold rounded-lg bg-[var(--accent-gold)] text-black hover:bg-[var(--accent-gold-dark)] transition-all duration-300 shadow-lg shadow-[var(--accent-gold)]/20">
                    See Hidden Deals Near Naperville
                    <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </Button>
                  <p className="text-sm text-white/60 mt-3 text-center">
                    Serving buyers across Naperville, Plainfield, Oswego, Aurora & surrounding suburbs.
                  </p>
                </div>
              </div>
            </form>
            </FormProvider>
          </div>

          {}
          <div className="mt-10 flex flex-wrap items-center gap-6">
            <div className="flex -space-x-3">
              {testimonials.map((img, i) => <img key={i} data-index={i} src={img.src} alt="Happy homeowner" className="size-12 rounded-full border-2 border-black object-cover" />)}
            </div>
            <div>
              <div className="flex gap-0.5 mb-1">
                {[...Array(5)].map((_, i) => <Star key={i} className="size-4 fill-[var(--accent-gold)] text-[var(--accent-gold)]" />)}
              </div>
              <p className="text-white/80 text-sm font-sans">
                <span className="font-bold text-white">Trusted by local buyers</span> just like you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}